import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { FieldFactory } from 'client/shared/components';
import { resetPassword } from 'aws-amplify/auth';

const addProps = (Comp, props) => {
	return class extends Component {
		render () {
			return <Comp { ...props } { ...this.props } />;
		}
	}
};

@inject('formStore', 'userStore')
@observer
class LoginForm extends Component {
	state = {
		isForgotPassword: false,
		forgotPasswordEmail: '',
		forgotPasswordSuccess: false,
		forgotPasswordError: null,
		isSubmitting: false
	}

	componentDidMount () {
		window.document.addEventListener('keypress', (e) => this.props.keyHandler({ key: e.key, user: this.props.userStore.items[0] }));
	}

	componentWillUnmount () {
		window.document.removeEventListener('keypress', (e) => this.props.keyHandler({ key: e.key, user: this.props.userStore.items[0] }));
	}

	render() {
		const { formStore, userStore, loginError } = this.props;
		const {
			isForgotPassword,
			forgotPasswordSuccess,
			forgotPasswordError,
			forgotPasswordEmail,
			isSubmitting
		} = this.state;

		if (userStore.isLoading || userStore.loginSuccess) {
			return <h1 style={{marginLeft:'33%', marginTop:'33%'}}>Logging in...</h1>;
		}

		const user = userStore.newUser();

		const Field = addProps(FieldFactory, {
			item: user,
			changeOnBlur: false,
			formStore: formStore,
			noFieldClass: true,
			inputClass: 'login-field'
		});

		let logoRoute = "";
		switch(import.meta.env.MODE) {
			case 'production':
				logoRoute = '/';
				break;
			case 'int':
				logoRoute = '/';
				break;
			default:
				logoRoute = "/main"
		}

		return (
			<div className="grid-x align-center">
				<div className="grid-x">
					<a className="cell small-12" href={logoRoute}><div className="logo-large" style={{transform:'scale(0.6)'}}></div></a>
					<div className="cell large-12 text-center" style={{width: '35vw',margin: '0 auto'}}>
						{!isForgotPassword ? (
							<>
								<Field fieldKey="user.userName" />
								<Field fieldKey="user.password" />
								{loginError}
								<div className="padding-top-1">
									<button
										className="button neo login"
										data-ta="submit"
										data-key="submit"
										onClick={ () => {
											this.props.clickHandler(user);
										}}
									>
										Log In
									</button>
									<button
										className="button neo secondary"
										onClick={this.handleForgotPasswordClick}
										style={{marginLeft: '10px'}}
									>
										Forgot Password?
									</button>
								</div>
							</>
						) : (
							<div>
								<h4>Reset Password</h4>
								{!forgotPasswordSuccess ? (
									<>
										<p style={{color: '#555', marginBottom: '1rem'}}>Enter your email address and we'll send you a reset link.</p>
										<input
											type="email"
											className="login-field"
											placeholder="Enter your email"
											value={forgotPasswordEmail}
											onChange={(e) => this.setState({ forgotPasswordEmail: e.target.value })}
										/>
										{forgotPasswordError && (
											<p style={{color: '#a94442'}}>{forgotPasswordError}</p>
										)}
										<div className="padding-top-1">
											<button
												className="button neo login"
												onClick={this.handleResetPasswordSubmit}
												disabled={isSubmitting}
											>
												{isSubmitting ? 'Sending...' : 'Send Reset Link'}
											</button>
											<button
												className="button neo secondary"
												onClick={() => this.setState({ isForgotPassword: false, forgotPasswordError: null })}
												style={{marginLeft: '10px'}}
											>
												Back to Login
											</button>
										</div>
									</>
								) : (
									<div style={{padding: '1rem 0'}}>
										<div style={{fontSize: '3rem', color: '#6f3c8a', marginBottom: '1rem'}}>
											<i className="fas fa-envelope-open-text"></i>
										</div>
										<h4>Check your email</h4>
										<p>We've sent a password reset link to <strong>{forgotPasswordEmail}</strong>. Click the link to choose a new password.</p>
										<p style={{fontSize: '13px', color: '#888', marginTop: '0.75rem'}}>Didn't receive it? Check your spam folder, or go back and try again.</p>
										<div className="padding-top-1">
											<button
												className="button neo secondary"
												onClick={() => this.setState({
													isForgotPassword: false,
													forgotPasswordSuccess: false,
													forgotPasswordError: null,
													forgotPasswordEmail: ''
												})}
											>
												Back to Login
											</button>
										</div>
									</div>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}

	@autobind
	handleForgotPasswordClick() {
		this.setState({ isForgotPassword: true });
	}

	@autobind
	async handleResetPasswordSubmit() {
		const { forgotPasswordEmail } = this.state;

		try {
			this.setState({ isSubmitting: true });
			await resetPassword({ username: forgotPasswordEmail });
			// Whether Cognito returns CONFIRM_RESET_PASSWORD_WITH_CODE or DONE,
			// we show the "check your email" screen. The Lambda sends a link.
			this.setState({
				forgotPasswordSuccess: true,
				forgotPasswordError: null
			});
		} catch (error) {
			this.setState({
				forgotPasswordError: error.message || 'An error occurred. Please try again.'
			});
		} finally {
			this.setState({ isSubmitting: false });
		}
	}
}

export default LoginForm;
